import React from 'react';
import { buttonStyle, sectionHeaderStyle } from './styles';

interface PerformanceBenchmarkProps {
  isRunning: boolean;
  simulationStats: Record<string, number> | null;
  onRunBenchmark: () => void;
}

export const PerformanceBenchmark: React.FC<PerformanceBenchmarkProps> = ({
  isRunning,
  simulationStats,
  onRunBenchmark
}) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Simulation Benchmark</div>
      <button
        style={buttonStyle}
        onClick={onRunBenchmark}
        disabled={isRunning}
      >
        ⚡ Run Performance Benchmark
      </button>

      {simulationStats && (
        <div style={{
          padding: '10px',
          background: 'rgba(155, 89, 182, 0.1)',
          borderRadius: '4px',
          marginBottom: '10px',
          fontSize: '11px'
        }}>
          <div style={{ color: '#9b59b6', fontWeight: 'bold', marginBottom: '5px' }}>
            Benchmark Results
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}>
            <div>Frames: <span style={{ color: '#fff' }}>{simulationStats.frames}</span></div>
            <div>Entities: <span style={{ color: '#fff' }}>{simulationStats.entities}</span></div>
            <div>Events: <span style={{ color: '#fff' }}>{simulationStats.events}</span></div>
            <div>Time: <span style={{ color: '#fff' }}>{simulationStats.benchmarkDuration?.toFixed(0)}ms</span></div>
          </div>
          <div style={{ marginTop: '5px', borderTop: '1px solid rgba(155, 89, 182, 0.2)', paddingTop: '5px' }}>
            FPS: <span style={{ color: '#2ecc71', fontWeight: 'bold' }}>
              {(simulationStats.frames / (simulationStats.benchmarkDuration! / 1000)).toFixed(1)}
            </span>
          </div>
        </div>
      )}
    </>
  );
};
